<template>
  <div class="basic_Block" :style="moduleStyle">
 
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'BasicImageIndex',
  components: {
  },
  data() {
    return {
      base64Img: ''
    }
  },
  props: {
    module: {
      type: Object,
      default: null
    }
  },
  computed: {
    moduleStyle() {
      let style = this.utils.getStyle(this.module.style)
      if (this.module.style['border-radius']) {
        style['border-radius'] = this.module.style['border-radius'] + 'px'
      }
      if (this.module.is_art && this.module.artType !== 'plainStroke' && this.module.properties) {
        style = {
          ...style
        }
      }
      return style
    },
    style() {
      const style = this.utils.getStyle(this.module.style)
      if (this.module.filterType || this.module.filterType === 0) {
        style.filter = this.utils.getFilterCss(this.module.filter)
      }

      style['objectFit'] = this.module.fit
      return style
    },
    borderStyle() {
      const dashMap = {
        shixian: '0',
        xuxian1: '3 3',
        xuxian2: '10 5'
      }
      return {
        'stroke': '#f00',
        'stroke-width': '4px',
        'stroke-dasharray': dashMap.xuxian2
      }
    },
    isDynamicFilter() {
      const dynamicKeys = [23, 24, 25, 26]
      return dynamicKeys.includes(this.module.filterType)
    }
  },
  watch: {
    'style.width'() {
      // this.module.new_edit = true;
    },
    'style.height'() {
      // this.module.new_edit = true;
    }
  },
  methods: {
    error(e) {
    //   const r = this.module.file.orikey || this.module.file.key || ''
    //   $(e.target).attr('src', r)
    },
    fixField() {
      if (!this.module.filter) {
        this.$set(this.module, 'filter', {
          'brightness': 0,
          'contrast': 0,
          'saturate': 0,
          'hueRotate': 0,
          'blur': 0
        })
        this.$set(this.module, 'filterType', 0)
      }
      if (!this.module.shadow) {
        this.$set(this.module, 'shadow', {
          x: 0,
          y: 0,
          blur: 0,
          color: '#000'
        })
      }
      if (!this.module.clipShape) {
        this.$set(this.module, 'clipShape', '')
      }
    },
    createLottie() {
    //   import( /* webpackChunkName: "lottie" */ 'lottie-web').then(lottie => {
    //     let filterConfig = filterList.find(item => item.type === this.module.filterType)
    //     lottie.loadAnimation({
    //       container: this.$refs.lottieWrapper,
    //       renderer: "svg",
    //       loop: true,
    //       autoplay: true,
    //       animationData: filterConfig.jsonPath,
    //       assetsPath: "https://staticjs.71360.com/static/suichuan/images/dynamicImg/"
    //       // assetsPath: "https://lib.eqh5.com/@eqxiu/editor-plugin/dynamicFilter/dynamicImg/"
    //     })
    //   })
    }
  },
  created() {
    this.fixField()
    const style = this.module.style
    if (typeof style['border-width'] === 'undefined') {
      style['border-width'] = 0
    }
  },
  mounted() {
    console.log(145, this.module)
    if (this.isDynamicFilter) {
    //   if ($(this.$el).parents('.page_list_wrapper').length) {
    //     // 左边的预览小图不显示，耗性能。
    //     return
    //   }
      this.createLottie()
    }
  }
}
</script>

<style lang="scss" scoped>
.basic_Block {
  position: relative;
  font-size: 0;
  overflow: hidden;

  img {
    box-sizing: content-box;
  }

  .my-img {
    vertical-align: top;
    // object-fit: cover;
  }

  .new_edit {
    object-fit: cover;
  }

  .lottie-wrapper {
    position: absolute;
    width: 120%;
    height: 120%;
    top: -10%;
    left: -10%;
    overflow: hidden;
  }

  .clip-border-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}
</style>
